import { useCurrentUser } from '@mp/hooks';
import { isSaasSchedulingAccount } from '@mp/utils';
import { useProfessionalSaasDetail } from './useProfessionalSaasDetail';
import { useSchedulingPrefsConfig } from './useSchedulingPrefsConfig';

export const useSchedulingPreferencesData = () => {
  const { currentUser, isSaas } = useCurrentUser();
  const { professionalSaasDetail } = useProfessionalSaasDetail(currentUser?.professional?.id);
  const { shiftPreferences, dayPreferences, frequencyPreferences, positionPreferences } =
    useSchedulingPrefsConfig();

  const hasSaasDetails = !!professionalSaasDetail?.id;

  const preferencesLastUpdatedAt = professionalSaasDetail?.preferences_last_updated_at;

  const hasAnyStatsigConfigEnabled =
    shiftPreferences || dayPreferences || frequencyPreferences || positionPreferences;

  const shouldShowSchedulingPreferences =
    isSaas && isSaasSchedulingAccount(currentUser) && hasSaasDetails && hasAnyStatsigConfigEnabled;

  return {
    shouldShowSchedulingPreferences,
    preferencesLastUpdatedAt,
  };
};
